var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('intestinal',{attrs:{"data":_vm.int_wor,"title":_vm.title[1],"lst_acc":_vm.lst_acc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }